
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import {formatMoneyTrunc} from "@/utils/formatter"
import MetricCircle from "@/report/components/MetricCircle.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"

@Component({
  name: "OverviewPage",
  components: {
    MetricCircle,
    Page,
  },
})
export default class OverviewPage extends AbstractPage {
  get planBalance(): string {
    return formatMoneyTrunc(this.lastSnapshot.totalAssetsOwned, undefined)
  }

  get averageBalance(): string {
    return formatMoneyTrunc(
      this.lastSnapshot.averageTotalAssetsOwned,
      undefined
    )
  }

  get members(): string {
    return String(this.lastSnapshot.countMembers)
  }
}
